export default __webpack_public_path__ + "static/uni_test-48373f4dbf077df1421abf6ae17463b1.svg";